'use client'

import { SizePicker } from 'product-card/components/shared/ProductSizes/SizePicker'
import { dataTestIds } from 'product-card/constants/dataTestIds'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { useProductCardInteractionContext } from 'product-card/hooks/useProductCardInteractionContext/useProductCardInteractionContext'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { cx } from 'utils/cx'
import { OverlayAddToBag } from './OverlayAddToBag/OverlayAddToBag'
import styles from './OverlayContent.module.scss'
import { OverlayLabel } from './OverlayLabel'

export const OverlayContent = () => {
	const { isLargeOrGreater, isTouchable } = useResponsive()

	const { isSizePickerVisible } = useProductCardInteractionContext()

	const { hasProductLabels, hasSizePicker, hasOverlayAddToBag } =
		useProductCardConsumerLayoutContext()

	const showOverlayAddToBagButton =
		hasOverlayAddToBag && (!isLargeOrGreater || isTouchable)

	return (
		<div
			className={cx(styles.container, isSizePickerVisible && styles.visible)}
			data-testid={
				isSizePickerVisible
					? dataTestIds.productCardVisibleOverlay
					: dataTestIds.productCardHiddenOverlay
			}
		>
			{hasProductLabels && <OverlayLabel />}
			{showOverlayAddToBagButton && <OverlayAddToBag />}
			{hasSizePicker && isLargeOrGreater && (
				<SizePicker isVisible={isSizePickerVisible} />
			)}
		</div>
	)
}
